module.exports = __webpack_public_path__ + "img/d16fef6.svg";